import { createFileRoute } from "@tanstack/react-router";
import { PlanningProvider } from "#/modules/les.planning/services/runtime";
import {
  VakantiesRouteDialog,
  vakantiesRouteOptions,
} from "#/modules/les.planning/vakanties-route";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/lessons/today/vakanties",
)({ ...vakantiesRouteOptions, component: Vakanties });

function Vakanties() {
  const params = Route.useParams();
  const navigate = Route.useNavigate();
  // The lesdag has no planning runtime of its own, unlike the rooster.
  return (
    <PlanningProvider tenant={{ school: params.school, schoolyear: params.schoolyear }}>
      <VakantiesRouteDialog
        params={params}
        onClose={() =>
          void navigate({
            to: "..",
            search: (prev) => prev,
            replace: true,
            resetScroll: false,
            viewTransition: true,
          })
        }
      />
    </PlanningProvider>
  );
}
